const Location = require('utils/Location.js');
const envUtils = require('utils/Env');

const pageHasCertona = () => {
    return (
        Location.isBasketPage() ||
        Location.isHomePage() ||
        Location.isProductPage() ||
        Location.isRootCategoryPage() ||
        Location.isMyProfilePage() ||
        Location.isContentStorePage() ||
        Location.isTargetedLandingPage() ||
        Location.isOrderConfirmationPage() ||
        Location.isCreditCardApplyPage() ||
        Location.isCreditCardTabPage() ||
        Location.isSearchPage() ||
        Location.isNoSearchResultsPage() ||
        Location.isLovesListPage() ||
        Location.isBrandNthCategoryPage() ||
        Location.isNthCategoryPage() ||
        Location.isPurchaseHistoryPage()
    );
};

const shouldServiceRun = {
    certona: function () {
        return pageHasCertona() && Sephora.isCertonaEnabled;
    },

    testTarget: function () {
        return true;
    },

    addStructure: function () {
        return Location.isProductPage();
    },

    search: function () {
        return Location.isSearchPage() || Location.isNoSearchResultsPage();
    },

    catalog: function () {
        return true;
    },
    refreshBasket: function () {
        return true;
    }
};

const buildServiceUrl = {
    certona: function () {
        const isProduction = envUtils.isUfeEnvProduction;
        const envPrefix = isProduction ? 'www.' : 'www.qa-';

        return `//edge1.certona.net/cd/1e15a405/${envPrefix}sephora.com/scripts/resonance.js`;
    }
};

const POST_LOAD_TIMEOUT = 15000;

module.exports = {
    shouldServiceRun,
    buildServiceUrl,
    POST_LOAD_TIMEOUT
};
